import { Button, Stack, Typography } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

import { ProgressDots } from './ProgressDots';
import { StyledCardStack, StyledContainerStack } from './Question.styled';

interface QuestionProps {
  totalQuestions: number;
  questionNumber: number;
  text: string;
  isShowBackButton?: boolean;
  onBack: () => void;
  onYes: () => void;
  onNo: () => void;
}

export const Question = ({
  isShowBackButton,
  onBack,
  onNo,
  onYes,
  questionNumber,
  text,
  totalQuestions,
}: QuestionProps): ReactElement => (
  <StyledContainerStack direction="column" gap={4} paddingX={3} paddingY={3}>
    <Stack direction="row" gap={2} alignItems="center">
      <Typography fontSize="sm" fontWeight="medium">
        Review Question {questionNumber}:
      </Typography>

      {/* Progress dots */}
      <ProgressDots currentStep={questionNumber - 1} totalSteps={totalQuestions} />
    </Stack>

    {/* Question */}
    <StyledCardStack gap={4} margin={40} paddingX={3} paddingY={3}>
      <Typography fontSize="sm" fontWeight="normal">
        {text}
      </Typography>
    </StyledCardStack>

    {/* Display navigation buttons */}
    <Stack direction="row" gap={3} justifyContent="space-between" alignItems="center">
      <Stack direction="row" gap={3} justifyContent="start">
        {isShowBackButton && (
          <Button variant="white" onClick={() => onBack()} rounded="regular" size="base">
            Back
          </Button>
        )}
      </Stack>
      <Stack direction="row" gap={3} justifyContent="end">
        <Button variant="primary" onClick={() => onYes()} rounded="regular" size="base">
          Yes
        </Button>
        <Button variant="primary" onClick={() => onNo()} rounded="regular" size="base">
          No
        </Button>
      </Stack>
    </Stack>
  </StyledContainerStack>
);
